export interface NavItem {
  instanceDynamicView?: boolean;
  displayName: string;
  disabled?: boolean;
  iconName?: string;
  svgIconName?: string;
  route?: string;
  children?: NavItem[];
  isDynamicForm?: boolean;
  entityName?: String;
  entityDescription?:String;
  visible:boolean;
  id:string;  
  nuMenu:string;
  expanded:boolean;
  hidden:boolean
  index?:number;
  showButton?:boolean;
  type?:string
  entities?:NavItemEntities[];
  sequence?:number;
  language?:{lang:string;text:string}[];
  selected?:boolean;
  level?:number;
}

export interface NavItemEntities{
  entityName?:string;
  titleInstance?:string;
  condition?:string;
  type:NavItemEntitiesTypeEnum;
  order?:number;
  canAccess?:boolean;
  idDashBoard?:number;
}

export enum NavItemEntitiesTypeEnum{
    treeview='treeview',
    gridview='gridview',
    dashboard='dashboard',
    component='component'
}